import { createContext, useContext } from "react";

import type { NautilusApi } from "./nautilusApiTypes.ts";

export interface NautilusApiContext {
  api: NautilusApi;
  hostId: string;
}

export const NautilusApiContext = createContext<NautilusApiContext | undefined>(undefined);
NautilusApiContext.displayName = "NautilusApiContext";

const useNautilusApiContext = () => {
  const context = useContext(NautilusApiContext);
  if (!context) {
    throw new Error(`No NautilusApiContextProvider.`);
  }
  return context;
};

const useNautilusApi = () => useNautilusApiContext().api;

export const useLanguagesApi = () => {
  return useNautilusApi().languages;
};

export const useContentLanguagesApi = () => {
  return useNautilusApi().contentLanguages;
};

export const useContentApi = () => {
  return useNautilusApi().nodeDesigns;
};

export const useCopilotApi = () => {
  return useNautilusApi().copilot;
};

export const useNodeTemplatesApi = () => {
  return useNautilusApi().nodeTemplates;
};

export const useThumbnailsApi = () => {
  return useNautilusApi().thumbnails;
};

export const useContentHostId = () => {
  return useNautilusApiContext().hostId;
};
